import type { MatchupRow } from "./types";

export function sortMatchupsByKickoff(matchups: MatchupRow[]): MatchupRow[] {
  return matchups
    .map((matchup, index) => ({ matchup, index }))
    .sort(
      (a, b) =>
        kickoffTime(a.matchup) - kickoffTime(b.matchup) || a.index - b.index,
    )
    .map(({ matchup }) => matchup);
}

function kickoffTime(matchup: MatchupRow): number {
  const parsed = matchup.kickoff ? Date.parse(matchup.kickoff) : NaN;
  return Number.isNaN(parsed) ? Number.POSITIVE_INFINITY : parsed;
}
